export enum StakingTableStatus {
  FINISHED = 'Finished',
  ACTIVE = 'Active',
  UPCOMING = 'Upcoming',
}

export enum StakingTab {
  STAKE = 'STAKE',
  VIP = 'VIP',
  EARNINGS = 'EARNINGS',
  GAMES_POOL = 'GAMES_POOL',
}

export enum EarningsFilterType {
  ACTIVE = 'Active',
  CLAIMED = 'Claimed',
  ALL = 'All',
}

export enum EarningsTableStatus {
  CLAIMED = 'Claimed',
  FINISHED = 'Finished',
  FLEXIBLE = 'Flexible',
  DAYS_LEFT = 'Days left',
  WITHDRAWN = 'Withdrawn',
}

export enum StakingPeriodDays {
  FLEXIBLE = '0',
  DAYS_1 = '1',
  DAYS_2 = '2',
  DAYS_3 = '3',
  DAYS_4 = '4',
  DAYS_7 = '7',
  DAYS_30 = '30',
  DAYS_90 = '90',
  DAYS_180 = '180',
  DAYS_360 = '360',
  DAYS_720 = '720',
}

export enum TransactionStatus {
  IDLE = 'idle',
  APPROVING = 'approving',
  PENDING = 'pending',
  CONFIRMING = 'confirming',
  SUCCESS = 'success',
  ERROR = 'error',
}

export type ColorVariant = 'default' | 'orange';
